module.exports = __webpack_public_path__ + "img/khmer_man.ce445977.png";